module.exports = __webpack_public_path__ + "static/media/video.93bf1bcd.mp4";